export default "__VITE_ASSET__CgKbI$nK__"